import React from "react";
import { Text, Stack } from "rsuite";

const ReportedLicensePeriodItem = ({ label, value }) => (
  <Stack direction="column" style={{ height: '100%', justifyContent: 'space-between' }} spacing={4}>
    <Stack.Item>
      <Text className="text-bold">{label}</Text>
    </Stack.Item>
    <Stack.Item>
      <Text className="text-large">{value}</Text>
    </Stack.Item>
  </Stack>
);

export default ReportedLicensePeriodItem; 
